/**
 * @fileoverview CaptionRenderer component for the Storyteller web application.
 * Displays a title with an optional icon and accent color.
 *
 * @example
 * // Basic usage
 * <CaptionRenderer text="Hello, World!" />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { Title } from '../../sections/Title'

/**
 * @function CaptionRenderer
 * @description Component for displaying a title with an optional icon and accent color.
 * @param {LabelProps & VanillaRendererProps} props - The props for the CaptionRenderer component.
 * @returns {JSX.Element} The CaptionRenderer component.
 */
function CaptionRenderer(props: LabelProps & VanillaRendererProps) {
    const { text, uischema } = props
    const { t } = useTranslation()
    return (
        <Title icon={uischema.options?.icon} accent={uischema.options?.accent}>
            {t(text)}
        </Title>
    )
}

export const CaptionTester = rankWith(3, uiTypeIs('Caption'))

export default withVanillaControlProps(withJsonFormsLabelProps(CaptionRenderer))
